var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1280"
    }
  }, [_c('console-title', [_c('span', [_vm._v("상품문의")])]), _c('console-search', {
    on: {
      "search": function search($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    }
  }, [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "검색조건",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "hide-details": "",
      "clearable": "",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1), _c('console-body', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "items": _vm.inquires,
      "headers": _vm.inquiresHeaders,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + +_vm.inquires.indexOf(item) + 1))])];
      }
    }, {
      key: "item.product",
      fn: function fn(_ref2) {
        var _item$product, _item$product2;

        var item = _ref2.item;
        return [_c('v-responsive', [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "shrink": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "width": "96",
            "height": "96",
            "contain": ""
          }
        })], 1), _c('v-flex', {
          staticClass: "text-start"
        }, [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_c('b', {
          domProps: {
            "innerHTML": _vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name)
          }
        })])])], 1)], 1)];
      }
    }, {
      key: "item.member",
      fn: function fn(_ref3) {
        var _item$member, _item$member2, _item$member3;

        var item = _ref3.item;
        return [item.member ? _c('div', [_c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$member = item.member) === null || _item$member === void 0 ? void 0 : _item$member.name))]), _c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$member2 = item.member) === null || _item$member2 === void 0 ? void 0 : _item$member2.phone))]), _c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$member3 = item.member) === null || _item$member3 === void 0 ? void 0 : _item$member3.email))])]) : _c('span', [_vm._v("탈퇴회원")])];
      }
    }, {
      key: "item.answer",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('span', [item.answer ? _c('span', [_vm._v("답변")]) : _c('span', [_vm._v("미답변")])])];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('span', [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('span', [_c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")])], 1)];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }